module.exports = __webpack_public_path__ + "bcd0c5ba3039daeb2fcb9a2f65929321.MP3";